import * as React from 'react';
import { getStoreState, subscribeToStoreState } from '../state/Store';
import User from '../data/User';

export default class extends React.Component<{}, {}> {
  _mounted = true;
  _unsubscribeFromStore?: Function;

  componentWillMount() {
    const user = getStoreState().app.user;
    if (user) {
      this.onUserReady(user);
    } else {
      this._unsubscribeFromStore = subscribeToStoreState(this._storeDidUpdate);
    }
  }

  _storeDidUpdate = () => {
    const user = getStoreState().app.user;
    if (user && user.uid) {
      if (this._mounted) {
        this.onUserReady(user);
        if (this._unsubscribeFromStore) {
          this._unsubscribeFromStore();
          this._unsubscribeFromStore = undefined;
        }
      }
    }
  };

  componentWillUnmount() {
    if (this._unsubscribeFromStore) {
      this._unsubscribeFromStore();
      this._unsubscribeFromStore = undefined;
    }
    this._mounted = false;
  }

  onUserReady(user: User) {
    // to override
  }
}



// WEBPACK FOOTER //
// ./src/components/ComponentWithUser.ts